// removed by extract-text-webpack-plugin
module.exports = {"TitleText":"Title__TitleText__2yp9c","TitleSubText":"Title__TitleSubText__1WLQP"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/Title/Title.css
// module id = 399
// module chunks = 0